module.exports = __webpack_public_path__ + "static/5-7b9cb592b8496cf22010754ef0e2bd17.png";